module.exports = __webpack_public_path__ + "static/media/L2-HTML5.26a7052d.svg";